import React, { useEffect } from "react";
import {
  Navigate,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { checkAuthAndRedirect } from "../../../utils/auth";
import TestConfigureDetailPanel from "./TestConfigureDetailPanel";
import TestPageShell from "./TestPageShell";
import type { ConfigureDetailLocationState } from "./testTypes";
import {
  resolveConfigureDetailState,
  saveAssignTestContext,
  saveConfigureDetailContext,
} from "./testRouteUtils";
import { decodeTestNameFromPath, useTestRoutes } from "./testRoutes";

const TestConfigureDetail: React.FC = () => {
  const { testName: testNameParam } = useParams<{ testName: string }>();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const locationState = location.state as ConfigureDetailLocationState | null;
  const routeTestName = decodeTestNameFromPath(testNameParam);
  const testId = searchParams.get("test_id") ?? undefined;
  const routes = useTestRoutes();

  useEffect(() => {
    checkAuthAndRedirect();
  }, []);

  const detailState = resolveConfigureDetailState(testId, locationState);

  useEffect(() => {
    if (detailState?.test) {
      saveAssignTestContext(detailState.test);
      saveConfigureDetailContext({
        test_id: detailState.test.test_id,
        subjects: detailState.subjects,
      });
    }
  }, [detailState]);

  if (
    !routeTestName ||
    !testId ||
    !detailState ||
    detailState.test.test_id !== testId
  ) {
    return <Navigate to={routes.configure} replace />;
  }

  return (
    <TestPageShell showCardSearch={false}>
      <TestConfigureDetailPanel
        test={detailState.test}
        subjects={detailState.subjects}
        initialBatchConfigs={detailState.batchConfigs}
      />
    </TestPageShell>
  );
};

export default TestConfigureDetail;
